import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onChangeBind = this.onChange.bind(this)
        this.onResetBind = this.onReset.bind(this)

        // UI
        this.$form = this.$('form')[0]
        this.$cards = this.$('item')
        this.$resultCounter = this.$('result-counter')[0]
        this.$labelSingular = this.$('label-singular')[0];
        this.$labelPlurial = this.$('label-plurial')[0];
        this.$feedback = this.$('feedback')[0]
        this.$resetButton = this.$('reset')[0]
    }

    // ===============
    // Lifecycle
    // ===============
    init() {
        this.bindEvents()
        this.onChange();
    }

    destroy() {
        this.unbindEvents()
    }

    // ===============
    // Events
    // ===============
    bindEvents() {
        this.$form.addEventListener('change', this.onChangeBind)
        this.$resetButton.addEventListener('click', this.onResetBind)
    }

    unbindEvents() {
        this.$form.removeEventListener('change', this.onChangeBind)
        this.$resetButton.removeEventListener('click', this.onResetBind)
    }

    // ===============
    // Callbacks
    // ===============
    onChange(e) {

        const form = new FormData(this.$form);
        const selectedType = form.get('type-action')
        const selectedProfile = form.get('profil')
        const selectedContent = form.get('type-content')
        const toolsOnly = form.get('toolsOnly') == 'on'

        let count = 0;

        this.$cards.forEach($card => {
            const categories = $card.dataset.categories.split(';');

            $card.classList.add('is-hidden');

            requestAnimationFrame(() => {
                if (
                    (selectedType === 'all'     || categories.includes(selectedType)) &&
                    (selectedProfile === 'all'  || categories.includes(selectedProfile)) &&
                    (selectedContent === 'all'  || categories.includes(selectedContent)) &&
                    (toolsOnly === false        || categories.includes('tool'))
                ) {
                    $card.classList.remove('is-hidden');
                    count++;
                } else {
                    $card.classList.add('is-hidden');
                }

                this.updateResultCount(count);
            });
        });
    }

    updateResultCount(count) {
        this.$resultCounter.textContent = count;

        if (count === 1) {
            this.$labelSingular.classList.remove('is-hidden');
            this.$labelPlurial.classList.add('is-hidden');
        } else {
            this.$labelSingular.classList.add('is-hidden');
            this.$labelPlurial.classList.remove('is-hidden');
        }

        if (count === 0) {
            this.$feedback.classList.remove('is-hidden');
        } else {
            this.$feedback.classList.add('is-hidden');
        }
    }

    onReset() {
        // Show all cards
        this.$cards.forEach($card => {
            $card.classList.add('is-hidden');

            requestAnimationFrame(() => {
                $card.classList.remove('is-hidden');
            });
        });


        // Reset form data
        this.$form.reset()

        // Update result count
        this.updateResultCount(this.$cards.length);
    }
}
